import React, { useRef, useEffect, useState } from 'react';
import p5 from 'p5';
import Knobs from './Knobs';
import './Sketch.css';
// import { initializeApp } from 'firebase/app';

const Sketch = () => {
  const [symmetry, setSymmetry] = useState(6);
  const [strokeSize, setStrokeSize] = useState(1);
  const [reset, setReset] = useState(false)
  const [color, setColor] = useState('#ffffff')
  const [sketchId, setSketchId] = useState()
  const [mode, setDrawMode] = useState('')

  let angle = 360 / symmetry;
  let xoff = 0;

  const canvasRef = useRef(null);

  useEffect(() => {
    const sketch = (p) => {
      setReset(false)
      p.setup = () => {
        const canvas = p.createCanvas(
          canvasRef.current.offsetWidth,
          canvasRef.current.offsetHeight
        );
        canvas.parent(canvasRef.current);
        p.background(1);
        p.smooth();
        p.noStroke();
      };
      if (mode === 'spiral') {
        p.draw = () => {
          if (p.mouseIsPressed && (p.mouseButton === p.LEFT)) {
            p.translate(p.width / 2, p.height / 2);
            let mx = p.mouseX - p.width / 2;
            let my = p.mouseY - p.height / 2;
            let pmx = p.pmouseX - p.width / 2;
            let pmy = p.pmouseY - p.height / 2;
            xoff += 1;
            for (let i = 0; i < symmetry; i++) {
              p.stroke(p.color(color));
              p.rotate(p.radians(angle));
              p.strokeWeight(strokeSize);
              p.line(mx, my, pmx, pmy);
              p.push();
              p.scale(1, -1);
              // p.line(mx, my, pmx, pmy);
              p.pop();
            }
          }
        };
      } else {
        p.draw = () => {
          if (p.mouseIsPressed && (p.mouseButton === p.LEFT)) {
            p.translate(p.width / 2, p.height / 2);
            let mx = p.mouseX - p.width / 2;
            let my = p.mouseY - p.height / 2;
            let pmx = p.pmouseX - p.width / 2;
            let pmy = p.pmouseY - p.height / 2;
            xoff += 1;
            for (let i = 0; i < symmetry; i++) {
              p.stroke(p.color(color));
              p.rotate(p.radians(angle));
              p.strokeWeight(strokeSize);
              p.line(mx, my, pmx, pmy);
              p.push();
              p.scale(1, -1);
              p.line(mx, my, pmx, pmy);
              p.pop();
            }
          }
        };
      }
      
      p.Reset = () => {
        p.background(0);
      };
    };

    const canvas = new p5(sketch, canvasRef.current);
    return () => {
      canvas.remove();
    };
  }, [symmetry, strokeSize, reset, color, sketchId, mode]);

  const downloadCanvas = () => {
    const chars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
    let result = '';
    for (let i = 0; i < 5; i++) {
      result += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    const canvas = document.getElementById('defaultCanvas0');
    const link = document.createElement("a");
    link.download = "6u5haman-" + result + ".jpg";
    link.href = canvas.toDataURL("image/jpeg", 1.0);
    link.click();
  };

  const resetCanvas = () => {
    setReset(true)
    setSketchId('')
  }

  const modeChange = () => {
    if (mode === 'spiral') {
      setDrawMode('')
    } else {
      setDrawMode('spiral')
    }
  }
  return (
    <div className="contain">
      <div className="knobs">
        <Knobs
          symmetry={symmetry}
          strokeSize={strokeSize}
          onSymmetryChange={setSymmetry}
          onStrokeSizeChange={setStrokeSize}
          downloadCanvas={downloadCanvas}
          color={color}
          onColorChange={setColor}
          onModeChange={modeChange}
        />
        <button className="bg-green-500 hover:bg-green-700 text-white py-2 px-2 mx-2 rounded" onClick={() => resetCanvas()}>Clear canvas</button>
        <div className='hide-mobile'><a className="mx-2 m-5 text-black underline rounded about" href="https://6u5haman.github.io/home/">About</a></div>
        <br></br>
        <div className='hide-mobile'><a className="mx-2 m-5 text-black underline rounded" target="_blank" href="http://twitter.com/share?text=@6u5haman%20(attach%20your%20sketch)">Show me your sketch</a></div>
      </div>
      <div className="canvas" ref={canvasRef}></div>
    </div>
  );
};

export default Sketch;